import React, { useState, useEffect } from "react";
import { Axios, Link, Redirect, Modal, $ } from "../../../Headers";

const WebBookContactInfo = () => {
  const [modelIsOpenForSubmit, setModelIsOpenForSubmit] = useState(false);
  const [modelIsOpenForResponse, setModelIsOpenForResponse] = useState(false);
  const [response, setResponse] = useState("");
  const [redirect, setRedirect] = useState(false);
  const [redirecttype, setRedirectType] = useState("");
  const [server, setServer] = useState("");
  const [subId, setSubId] = useState(null);
  const [subData, setSubData] = useState([]);

  const action = (data) => {
    setSubId(data.s_id);
    setModelIsOpenForSubmit(true);
  };

  const insertData = (event) => {
    event.preventDefault();
    setModelIsOpenForSubmit(false);
    Axios.post("//" + window.$name + "/controller/InsertSubscription.php", {
      sub_id: subId,
    })
      .then((res) => {
        setResponse(res.data.Msg);
        setModelIsOpenForResponse(true);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    const serverName = window.$name;
    setServer(serverName);

    Axios.post(
      "//" + serverName + "/controller/GetWebBookContactInfoController.php"
    )
      .then((res) => {
        setSubData(res.data);

        const dataTable = $("#table").DataTable({
          responsive: true,
          fnRowCallback: function (
            nRow,
            aData,
            iDisplayIndex,
            iDisplayIndexFull
          ) {
            const index = iDisplayIndexFull + 1;
            $("td:first", nRow).html(index);
            return nRow;
          },
          columnDefs: [
            { className: "dt-center", targets: "_all" },
            { responsivePriority: 1, targets: -1 },
            { responsivePriority: 2, targets: 1 },
            { responsivePriority: 3, targets: 0 },
          ],
        });

        $("#searchbox").on("keyup search input paste cut", function () {
          dataTable.search(this.value).draw();
        });
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  if (redirect && redirecttype === "next") {
    return <Redirect to={"/article/" + subId} />;
  }

  return (
    <div>
      <div id="ss-uad-article-01">
        <div className="row" id="ss-uad-article-02">
          <div
            className="col-4"
            style={{ display: "flex", alignItems: "center" }}
          >
            <p id="ss-uad-admin-02">Contact Info</p>
          </div>

          <div className="col-4"></div>
        </div>
        <div className="card-body" id="card_body">
          <div className="container-fluid">
            <center>
              <table
                id="table"
                className="display hover dt[-head|-body]-justify"
                style={{ width: "100%" }}
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Book Title</th>
                    <th>Isbn</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Mobile</th>
                    <th>Copy</th>
                    <th>Created At</th>
                  </tr>
                </thead>
                <tbody>
                  {subData.map((data) => (
                    <tr key={data.id}>
                      <td></td>
                      <td>{data.book_title}</td>
                      <td>{data.isbn}</td>
                      <td>{data.first_name+" "+data.last_name}</td>
                      <td>{data.email}</td>
                      <td>{data.mobile}</td>
                      <td>{data.copy}</td>
                      <td>{new Date(data.created_at).toDateString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </center>
          </div>
        </div>
      </div>
      <Modal
        isOpen={modelIsOpenForSubmit}
        className="popup-modal-content-subscribe"
        overlayClassName="popup-modal"
        onRequestClose={() => setModelIsOpenForSubmit(false)}
      >
        <span
          className="closed"
          type="button"
          style={{
            fontSize: "32px",
            position: "absolute",
            zIndex: "1",
            right: "3%",
            height: "6.7vh",
            lineHeight: "6.7vh",
          }}
          onClick={() => setModelIsOpenForSubmit(false)}
        >
          &times;
        </span>
        <div
          className="card-header"
          id="ss-uad-article-10"
          style={{ justifyContent: "flex-start", paddingLeft: "5%" }}
        >
          <span id="ss-uad-article-12">Alert</span>
        </div>
        <div className="card-body">
          <p id="assign-popup-box-msg">
            Are you Sure want to approve the Subscription?
          </p>
          <div
            className="row"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <button
              id="ss-uad-article-09"
              style={{
                height: "50px",
                lineHeight: "initial",
                padding: "initial",
                width: "110px",
              }}
              className="btn btn-primary mr-2 col-5"
              type="submit"
              onClick={insertData}
            >
              Accept
            </button>
            <button
              id="ss-uad-article-08"
              style={{
                height: "50px",
                lineHeight: "initial",
                padding: "initial",
                width: "110px",
              }}
              className="btn btn-danger col-5"
              onClick={() => setModelIsOpenForSubmit(false)}
            >
              Reject
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={modelIsOpenForResponse}
        className="popup-modal-content-success"
        overlayClassName="popup-modal"
        onRequestClose={() => setModelIsOpenForResponse(false)}
      >
        <div className="row" style={{ height: "100%", margin: "0px" }}>
          <div className="col-9" style={{ paddingTop: "6px" }}>
            <p id="popup-title">Remark</p>
            <p id="popup-content">{response}</p>
          </div>
          <div
            className="col-3"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <button
              id="ss-uad-article-09"
              style={{
                height: "50px",
                lineHeight: "initial",
                padding: "initial",
                width: "110px",
              }}
              className="btn btn-primary"
              onClick={() => window.location.reload()}
            >
              <i className="fas fa-check" style={{ fontSize: "29px" }}></i>
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default WebBookContactInfo;
